import $axios from '@/service/httpServer'


export const getVisaList = params=>$axios.get(`/pdp/xcx/change/changeInfos`, params); //获取签证变更列表

export const getVisaStatistics =params=>$axios.get(`/pdp/xcx/change/statistics`, params)  //获取签证概览

export const getVisaListByid = params=>$axios.get(`/pdp/xcx/change/logInfo`, params); //根据签证id查询列表

export const getVisaStatisticsByid =params=>$axios.get(`/pdp/xcx/change/statisticsInfo`, params)  //根据签证id查询概览